<template>
  <div  v-loading="busy">
      <!-- {{fetching ? 'Fetching from server': (loading ? 'Loading Content' : 'Loaded.')}}
      {{type}} -->
      <slot v-bind:props="{
        busy,
        canBrowserRead,
        showPopup,
        download,
        srcResult
      }">
      <el-button type="text" v-if="canBrowserRead" @click="showPopup">
        View
      </el-button>
      </slot>
      <!-- <el-button v-if="!canBrowserRead" type="text" @click="download">
        Download
      </el-button> -->
      <el-dialog v-if="canBrowserRead" title="Preview" center 
        :show-close="false"
        :fullscreen="true" 
        :visible.sync="dialogTableVisible">
        <template slot="title">
          Preview 
          <i class="el-icon-close" :style="{
            fontSize: '25px',
            position: 'relative'
          }" @click="dialogTableVisible = false">
          </i>
        </template>
        <template>    
          <div v-if="!busy && type && isImage(type)" style="display: flex; justify-content: center; align-items: center; height: 85vh; width: 100%; overflow: auto;">
            <img :src="srcResult" style="max-width: 100%; max-height: 100%; object-fit: contain; display: block;" />
          </div>
          <el-row :gutter="20" style="overflow: hidden;">
            <el-col :span="2">
                <el-row :gutter="20">
                  <!-- <el-col :span="24">
                    <div class="pdf_page_box">{{currentPage}} / {{pageCount}}</div>
                  </el-col> -->
                  <el-col 
                    :span="22"                  
                    v-for="page in pageCount"
                    :key="`page${page}`"
                  >
                    <div 
                      @click="changePage(page)" 
                      :class="`pdf_page_box page_box_border ${page == currentPage ? 'selected': ''}`"
                    >
                      <pdf
                        style="width: 100%" 
                        ref="pdf"
                        :src="srcResult"
                        :page="page" 
                      />
                    </div>
                  </el-col>
                </el-row>
            </el-col>
            <el-col :span="20">
              <div style="width: 100%">
              <pdf v-if="dialogTableVisible && !busy && type && isPDF(type)"
                ref="pdf" style="border:1px solid #696363; width: 100%" 
                :src="srcResult"
                :page="currentPage"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event">
              </pdf>
              </div>
            </el-col>
          </el-row> 
        </template>       
      </el-dialog>
  </div>
</template>
<script>
import { get as readMedia } from '../api/media'
import pdf from 'vue-pdf'
const FileDownload = require('js-file-download');

export default {
  props: {
    mediaId: {
      type: Number,
      required: true
    },
    fileName: String
  },
  components: {
    pdf
  },
  data () {
    return {
      dialogTableVisible: false,
      srcResult: null,
      loading: false,
      fetching: false,
      canBrowserRead: false,
      type: '',
      response: null,
      currentPage: 1,
      pageCount: 0,
    }
  },
  watch: {
    mediaId: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          this.mediaRequest(newVal);
        } else if (!newVal) {
          this.srcResult = null;
          this.response = null;
        }
      },
      immediate: true,
    }
  },
  computed: {
    pages () {
      let items = []
      for (let page = 1; page <= this.pageCount; page++) {
        items.push({
          value: page,
          label: 'Item ' + page
        })
      }
      return items;
    },
    busy () {
      return this.loading || this.fetching
    }
  },
  methods: {
    mediaRequest(id) {
      this.fetching = true;
      readMedia(id)
        .then((response) => {
          this.response = response;
          this.loading = true;
          this.fetching = false;
          let fileReader = new FileReader();
          // console.log('blob', response)
          this.type = response.type;

          if (this.isImage(response.type) || this.isPDF(response.type)) {
            this.canBrowserRead = true;
          } else {
            this.canBrowserRead = false;
          }
          fileReader.onload =  (evt) => {
            // Read out file contents as a Data URL
            this.srcResult = evt.target.result;
            this.loading = false;
            
          };
          // Load blob as Data URL
          fileReader.readAsDataURL(response);
          // console.log('I am loaded..', fileReader)
        }).catch((e) => {
          console.log('Errr', e)
          this.fetching = false
        })
    },
    isImage(str) {
      return str.startsWith('image/');
    },
    isPDF(str) {
      return str  === 'application/pdf'
    },
    showPopup () {
      if (this.busy) {
        this.$message.info('Content is Laoding...')
        return;
      }
      this.dialogTableVisible = true;
    },
    download() {
      FileDownload(this.response, this.fileName);
    },
    changePage(page) {
      // console.log('Tesy  g')
      // alert(page)
      this.currentPage = page
    }
  }
}
</script>
<style >
  .pdf_page_box {
    padding: 10px;
    margin-bottom: 10px;
  }
  .page_box_border {
    border: 1px solid gainsboro;
  }
  .page_box_border.selected {
    border: 1px solid #696363;
  }
</style>
